module.exports = __webpack_public_path__ + "fe55242e4799283e5c5e8cb73b713784.svg";